
(() => {
  const init = () => {
    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const drawer = document.getElementById('EroniaMobileMenu');
    const closeBtn = drawer && drawer.querySelector('[data-mobile-menu-close]');
    const overlay = document.querySelector('[data-mobile-menu-overlay]');
    if (!openBtn || !drawer || !closeBtn || !overlay || openBtn.dataset.bound === 'true') return;

    openBtn.dataset.bound = 'true';
    let lastFocus = null;

    const focusables = () => [...drawer.querySelectorAll(
      'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.hasAttribute('hidden'));

    const open = () => {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        overlay.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden','false');
      openBtn.setAttribute('aria-expanded','true');
      document.body.classList.add('mobile-menu-open');
      closeBtn.focus();
    };

    const close = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden','true');
      openBtn.setAttribute('aria-expanded','false');
      document.body.classList.remove('mobile-menu-open');
      window.setTimeout(() => { overlay.hidden = true; }, 320);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);

    drawer.querySelectorAll('a[href]').forEach(a => a.addEventListener('click', close));

    document.addEventListener('keydown', e => {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        const els = focusables();
        if (!els.length) return;
        const first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* V26 — move mobile drawer layers directly under <body> to avoid hero stacking contexts */
document.addEventListener('DOMContentLoaded', function(){
  const drawer = document.getElementById('EroniaMobileMenu');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  if(drawer && drawer.parentElement !== document.body){
    document.body.appendChild(drawer);
  }
  if(overlay && overlay.parentElement !== document.body){
    document.body.appendChild(overlay);
  }
});
